import { useEffect, memo } from 'react'
import { connect } from 'react-redux'
import { login } from '../actions'
import { history } from '../store'
import { isTokenValid, verifyAndSetToken } from '../utils'
import withToken from '../containers/withToken'
import { withRouter } from 'react-router-dom'

const Login = ({ login, location }) => {
  useEffect(() => {
    async function fetchData() {
      const isValid = await isTokenValid()

      if (isValid && !location.search) {
        history.push('/clubs')
        return
      }

      verifyAndSetToken()
      window.Eduzz.Accounts.login(process.env.REACT_APP_EDUZZ_PARTNER, {
        logo: `${window.location.origin}/alumy-logo.png`,
        bg:
          'https://assets.website-files.com/5ce2e037d0cadb4000334a68/5d3b70f4850abc6e83bd2bfe_bg-hero-alumy.png',
        btnColor: '#6200EE',
        env: process.env.REACT_APP_EDUZZ_ACCOUNTS_ENV,
        create: 'false',
        register: 'false'
      }).subscribe((token) => {
        login({
          token,
          redirectTo: location.search
            ? location.search.split(/redirectTo=([^&]*)/)[1] &&
              location.search.split(/redirectTo=([^&]*)/)[1].replace(/\/$/, '')
            : null
        })
      })
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

const mapDispatchToProps = (dispatch) => ({
  login: ({ token, redirectTo }) => dispatch(login({ token, redirectTo }))
})

export default withToken(
  withRouter(connect(null, mapDispatchToProps)(memo(Login)))
)
